import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-transf',
  templateUrl: './create-transf.component.html',
  styleUrls: ['./create-transf.component.scss']
})
export class CreateTransfComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
